import { Component, OnInit, ViewChild } from '@angular/core';
import { GlobalVariablesService } from '@services/global-variables/global-variables.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { GlobalVariablesEditComponent } from './global-variables-edit/global-variables-edit.component';
import { DataTableComponent } from '../../components/data-table/data-table.component';

@Component({
  selector: 'app-global-variables',
  templateUrl: './global-variables.component.html',
  styleUrl: './global-variables.component.scss',
  providers: [GlobalVariablesService],
  standalone: false
})
export class GlobalVariablesComponent implements OnInit {
  @ViewChild(DataTableComponent) dataTable: DataTableComponent;
  columns = [{ prop: 'name', title: 'Name' }];
  headerButtons = [{ icon: 'add', callback: () => this.add() }];

  constructor (public varService: GlobalVariablesService, private dialog: MatDialog) {

  }

  ngOnInit() {

  }

  async add() {
    let dialogRef: MatDialogRef<GlobalVariablesEditComponent>;
    dialogRef = this.dialog.open(GlobalVariablesEditComponent, {});
    const res = await dialogRef.afterClosed().toPromise();
    if (res) {
      await this.varService.create(res);
      return this.dataTable.page();
    }
  }

  async edit(event: any) {
    let dialogRef: MatDialogRef<GlobalVariablesEditComponent>;
    dialogRef = this.dialog.open(GlobalVariablesEditComponent, { data: event?.row});
    const res = await dialogRef.afterClosed().toPromise();
    if (res) {
      await this.varService.update(event.row._id, res);
      return this.dataTable.page();
    }
  }
}
